import { forwardRef } from "react";
import { IconSparkles } from "@tabler/icons-react";
import { mapAnnualPlans } from "./mapAnnualPlans";
import styles from "../subscriptionPayment.module.css";
import PriceCard from "./PriceCard";

const PricingSection = forwardRef(function PricingSection(
  { onCta, apiData, currency, activeSubscription },
  ref,
) {
  const annualPlans = mapAnnualPlans(apiData, {
    currency,
    activeSubscription,
  });
  return (
    <div className={styles.card} ref={ref}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconSparkles size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Annual Credit Plans</div>
            <div className={styles.cardSubtitle}>
              Pay once, get your full year of credits upfront. Valid 1 year from
              purchase — no monthly billing. Prices in ₦ for Nigerian-registered
              companies.
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.cardBody} ${styles.cardBodyTopPad24}`}>
        <div className={`${styles.pricingGrid} ${styles.pricingGridPlans4}`}>
          {annualPlans?.map((plan) => (
            <PriceCard key={plan?.id} {...plan} onCtaClick={() => onCta(plan)} />
          ))}
        </div>

        <div className={styles.planTermsNote}>
          Plans are valid 1 year from purchase — buying a new plan resets the
          clock from the new date. Unused credits roll over; if your plan lapses
          they're frozen, not lost. Upgrade any time; downgrades apply at
          renewal.
        </div>
      </div>
    </div>
  );
});

export default PricingSection;
